import ScrapingTemplateCard, {
  ScrapingTemplateCardProps,
} from '@/decodo/blocks/ScrapingTemplateLibrary/Components/ScrapingTemplateCard';
import Card from '@/decodo/components/atoms/Card';
import ImageStrapi from '@/decodo/components/atoms/Image/ImageStrapi';
import LinkButton from '@/decodo/components/atoms/LinkButton';
import { Text } from '@/decodo/components/atoms/Text';
import { SCRAPING_CARD_DATA_TRACKER_COMPONENT } from '../../ScrapingTemplateLibrary/consts';

import { cn } from '@/lib/utils';
import './styles.css';

export const templateCardStyles: ScrapingTemplateCardProps['classNames'] = {
  // NOTE: Once the flip animation finishes, the hover doesn't propagate to the card, so the hover effect is lost.
  // Also, ito nly applies to desktop.
  card: {
    root: cn(
      'text-left',
      'md:bg-brand-25 md:hover:bg-brand-25 md:border-brand-500',
      'md:dark:border-brand-500 md:dark:bg-brand-975'
    ),
  },
  content: 'line-clamp-4 text-gray-975',
  button: {
    root: 'hidden',
  },
};

type Props = {
  card: ScrapingTemplateCardProps;
};

const ScrapingTemplatePreviewCard = (props: Props) => {
  const FlippedContent = () => (
    <ScrapingTemplateCard {...props.card} classNames={templateCardStyles} />
  );

  const InitialContent = () => (
    <LinkButton
      href={props.card.cta.url}
      noStyles
      className='h-full'
      data-tracker-component={SCRAPING_CARD_DATA_TRACKER_COMPONENT}
    >
      <Card
        hasShadow
        classNames={{
          root: 'px-6 py-8 flex flex-col flex-1 h-full content-between hover:bg-brand-50 dark:border-gray-dark-600',
        }}
      >
        <ImageStrapi
          block={props.card.image}
          inner={{
            classNames: { image: 'w-full h-20 mx-auto mb-8' },
          }}
          width={370}
          height={80}
        />
        <Text variant='h3'>{props.card.title}</Text>
      </Card>
    </LinkButton>
  );

  return (
    <div className={cn('flip-card h-[220px] min-h-fit w-full cursor-pointer')}>
      <div className='flip-card-inner relative h-full w-full'>
        <div className='flip-card-front absolute h-full w-full'>
          <InitialContent />
        </div>
        <div className='flip-card-back absolute h-full w-full'>
          <FlippedContent />
        </div>
      </div>
    </div>
  );
};

export default ScrapingTemplatePreviewCard;
